import { AddTicketBasketRequestApiFrom } from '@api-gen/models/add-ticket-basket-request-api-from';


export enum BasketPaymentStatus {
    Locked = 'locked',
    NotPaid = 'notPaid',
}

export type BasketModelWithLocalFields = AddTicketBasketRequestApiFrom & {
    status?: BasketPaymentStatus;
    total?: number;
    totalSource?: number;
    basketItems: BasketItemModel[];
};

export interface BasketItemModel {
    trfId: number;
    trfName: string;
    price: number;
    cnt?: number;
    stopFrom?: number;
    stopTo?: number;
    stopFromName?: string;
    stopToName?: string;
    fromDate?: string;
    calendarType?: 'M' | 'D' | 'H';
    trmOrgId?: number;
    trmOrgName?: string;
    dtgId: number;
    dtgName: string;
}
